<template>
    <v-overlay
        :absolute="true"
        v-model="active"
        color="#f3f6f9"
        opacity="0.9"
    >
        <v-container
            fluid
            fill-height
        >
            <v-layout
                justify-center
                align-center
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                />
            </v-layout>
        </v-container>
    </v-overlay>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            active: 'overlay/active',
        }),
    },
};
</script>
